import { Tabs } from 'antd';
import styled from 'styled-components';

import { Button } from '@/components-ant/button';

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid var(--gray-4);
  min-width: 0;

  //padding-left: 32px;
  padding-right: 32px;
  & {
    margin-left: -32px;
    margin-right: -32px;
  }

  .ant-tabs {
    min-width: 0;
    margin-left: 32px;
  }

  .ant-tabs-nav {
    margin: 0;

    &:before {
      border: none !important;
    }
  }

  .ant-tabs-tab-active .ant-tabs-tab-btn {
    font-weight: 600;
    color: var(--blue-6);
  }

  .ant-tabs-tab {
    padding-top: 8px;
  }
`;

export const TabsAndAddWrapper = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  min-width: 0;
`;

// pushing up by counteracts the bottom border of the tabs (2px) and their greater bottom padding (12px bottom vs 8px top)
// to align the button with the tab text
export const ButtonWrapper = styled.div`
  margin-bottom: 6px;
`;

export const StyledTabs = styled(Tabs)`
  .ant-tabs-ink-bar {
    background: var(--blue-6);
  }

  & {
    margin-left: -32px;
    margin-right: -32px;
  }

  .ant-tabs-nav-wrap {
    margin-left: 32px;
    margin-right: 32px;
  }

  .ant-tabs-tab {
    padding-top: 8px;
  }
`;

export const CancelButton = styled(Button)`
  color: var(--gray-7);
  &:hover,
  &:focus {
    color: var(--gray-6);
  }
`;
